import { FunctionComponent, useState, useEffect } from 'react'
import useStyles from './styles'
import LoadingPage from '@/components/LoadingPage'
import { Text } from '@conexasaude/conexa-hero'
import { useRealtimeAttendanceContext } from '@/modules/RealtimeAttendance/contexts/RealtimeAttendanceContext'
import Icon from '@/components/RebrandedHeroIcons'

const MagicLInkWithoutAttendance: FunctionComponent = () => {
  const styles = useStyles()
  const [isLoading, setIsLoading] = useState(true)

  const { realtimeAttendance } = useRealtimeAttendanceContext()

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false)
    }, 30000)
  }, [realtimeAttendance.scheduled])

  return (
    <div css={styles.validateWrapper}>
      <div css={styles.mainWrapper}>
        {isLoading ? (
          <div>
            <Text renderAs="h2">
              Um instante, estamos validando o seu atendimento.
            </Text>
            <LoadingPage withoutNav />
          </div>
        ) : (
          <div>
            <Text renderAs="h2">
              Não há atendimento agendado no momento ou o atendimento já foi
              finalizado pelo profissional de saúde.
            </Text>
            <Icon size="224px" name="canceled-modal-woman" />
          </div>
        )}
      </div>
    </div>
  )
}

export default MagicLInkWithoutAttendance
